export function SunLayer() {
  return <div className="sun-layer" />;
}

export function Skyhaze() {
  return <div className="sun-haze" />;
}

export function Sky() {
  return <div className="sky" />;
}
